// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import { sortControlStyles } from "@sc/Overrides/Widgets/MyLists/MyListsSortControl";
import { fontConfig } from "@sc/XDL/PreStyle/typography";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

sortControlStyles.sortBySelect = {
    sizeVariant: "small",
    labelProps: {
        size: 14,
        lineHeight: "22px",
        weight: fontConfig.weight.regular,
        css: css`
            line-height: 22px;
            width: fit-content;
            padding: 2px 8px 0 0;
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            width: 263px;
            ${xScreen("lte", "xs")} {
                width: 100%;
            }
        `,
        formField: css`
            row-gap: 4px;
        `,
    },
};
